define(function (require) {
    "use strict";

    var Backbone = require("backbone");

    var LinkModel = Backbone.Model.extend({
        defaults: {
            href: "",
            text: "",
            tooltip: "",
            tabindex: ""
        },

        initialize: function (options) {
            this.href = options.href;
            this.text = options.text;
            this.tooltip = options.tooltip || "";
            this.tabindex = options.tabindex || "";
        }
    });

    return LinkModel;
});
